import styled from "styled-components"

const StyledLink = styled.a`
  background-color: ${(props) => props.theme.a_color_gradients.a_dark};
`

export { StyledLink }
